import React, { useState } from 'react';
import LitStructuredText from './generic/LitStructuredText';
import { graphql } from 'gatsby';
import LitImage from './images/LitImage';
import { Link } from 'gatsby';
import SpeedAnimation from './SpeedAnimation';

const ModularImageHeaderParagraph = ({ data }) => {
  /* PurgeCSS include: Yellow, White, Black */
  return data.imageHeaderParagraphContent?.map(
    ({ heading, modularContent, isheader, backgroundColor }, index) => {
      return (
        <div
          className="modular-image-header-paragraph-container modular-heading-secondary"
          key={index}
        >
          {isheader && (
            <div className={`${backgroundColor}`}>
              <div
                className={`modular-header modular-text-center modular-global-width`}
              >
                <LitStructuredText data={heading} basic />
              </div>
            </div>
          )}
          <div className="image-header-paragraph-content">
            {modularContent?.map(
              (
                {
                  backgroundColor,
                  content,
                  heading,
                  featureImageDesktop,
                  body,
                  secondaryBody,
                  featureImage,
                  idContent,
                  button,
                  buttonText,
                  buttonPath,
                  noTopPadding,
                  noBottomPadding,
                  rowReverse,
                  speedAnimation,
                  speedAnimationNumber,
                  speedText,
                  speedImage,
                  textAlign,
                  buttonOverlapText,
                  buttonOverlapPath,
                  buttonOverlapPdf,
                  isExternalButtonPath,
                },
                index,
              ) => {
                return (
                  <div
                    className={`${backgroundColor} ${
                      noBottomPadding && 'modular-padding-large-no-bottom'
                    } ${noTopPadding && 'modular-padding-large-no-top'} ${
                      !noBottomPadding &&
                      !noBottomPadding &&
                      'modular-padding-large'
                    } ${index}`}
                    id={idContent}
                    key={index}
                  >
                    <div
                      className={`${
                        rowReverse
                          ? 'image-header-paragraph-inner-reverse'
                          : 'image-header-paragraph-inner'
                      } `}
                    >
                      {/* PurgeCSS include: Left, Right, Centre, default-align*/}
                      <div className={`content-container`}>
                        <div
                          className={`${textAlign && textAlign} ${
                            !textAlign && 'default-align'
                          }`}
                        >
                          {heading && (
                            <div className="modular-heading-third modular-heading-secondary">
                              <LitStructuredText data={heading} basic />
                            </div>
                          )}

                          <div className="content modular-p">
                            {body && <LitStructuredText data={body} basic />}
                            {content && (
                              <LitStructuredText data={content} basic />
                            )}
                            {secondaryBody && (
                              <LitStructuredText data={secondaryBody} basic />
                            )}
                          </div>

                          {buttonPath ? (
                            !buttonPath.includes('http') ? (
                              <Link to={buttonPath} className="button">
                                {buttonText}
                              </Link>
                            ) : (
                              <a
                                href={buttonPath}
                                target="_blank"
                                className="button"
                              >
                                {buttonText}
                              </a>
                            )
                          ) : (
                            buttonOverlapPdf?.url && (
                              <a
                                href={buttonOverlapPdf?.url}
                                className="button"
                                target="_blank"
                              >
                                {buttonText}
                              </a>
                            )
                          )}
                        </div>
                      </div>

                      {!buttonOverlapText && (
                        <div className="image-container">
                          <LitImage
                            image={featureImage ?? featureImageDesktop}
                          />
                          {speedAnimation && (
                            <SpeedAnimation
                              speedAnimationNumber={speedAnimationNumber}
                              speedText={speedText}
                              speedImage={speedImage}
                            />
                          )}
                        </div>
                      )}
                      {buttonOverlapText && (
                        <div className="image-container-overlap">
                          <div className="image">
                            <LitImage
                              image={featureImage ?? featureImageDesktop}
                            />
                          </div>
                          {!buttonOverlapPdf ? (
                            <Link to={buttonOverlapPath} className="button">
                              {buttonOverlapText}
                            </Link>
                          ) : (
                            <a
                              href={buttonOverlapPdf?.url}
                              className="button"
                              target="_blank"
                            >
                              {buttonOverlapText}
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      );
    },
  );
};

export default ModularImageHeaderParagraph;
export const fragment = graphql`
  fragment ModularImageHeaderParagraph on DatoCmsImageHeaderParagraph {
    internal {
      type
    }
    imageHeaderParagraphContent {
      heading {
        value
      }
      backgroundColor
      isheader
      modularContent {
        ... on DatoCmsHeadingContentImageButtonBlock {
          noTopPadding
          noBottomPadding
          rowReverse
          speedAnimation
          speedAnimationNumber
          speedText {
            value
          }
          speedImage {
            gatsbyImageData
          }
          id
          featureImageDesktop {
            gatsbyImageData
          }
          idContent
          buttonText
          buttonPath
          isExternalButtonPath
          button
          backgroundColor
          textAlign
          buttonOverlapText
          buttonOverlapPath
          buttonOverlapPdf {
            url
          }
          content {
            value
            links {
              __typename
              ... on DatoCmsMediaModel {
                id: originalId
                media {
                  gatsbyImageData
                }
              }
              __typename
              ... on DatoCmsMediaText {
                id: originalId
                mediaImage {
                  gatsbyImageData
                }
                header {
                  value
                }
                content {
                  value
                }
              }
            }
          }
          heading {
            value
          }
        }
        ... on DatoCmsHeadingImageBodyBlock {
          noTopPadding
          noBottomPadding
          rowReverse
          backgroundColor
          speedAnimation
          id
          idContent
          body {
            value
          }
          heading {
            value
          }
          featureImage {
            gatsbyImageData
          }
        }
        ... on DatoCmsImageBodyBlock {
          noTopPadding
          noBottomPadding
          rowReverse
          id
          backgroundColor
          featureImageDesktop {
            gatsbyImageData
          }
          featureImageMobile {
            gatsbyImageData
          }
          secondaryBody {
            value
            links {
              __typename
              ... on DatoCmsBlogArticleModel {
                id: originalId
                slug
              }
              ... on DatoCmsNewsArticleModel {
                id: originalId
                slug
              }
              ... on DatoCmsModularPage {
                id: originalId
                slug
              }
              ... on DatoCmsSimpleWebsitePageModel {
                id: originalId
                slug
              }
            }
          }
          body {
            value
            links {
              __typename
              ... on DatoCmsBlogArticleModel {
                id: originalId
                slug
              }
              ... on DatoCmsNewsArticleModel {
                id: originalId
                slug
              }
              ... on DatoCmsModularPage {
                id: originalId
                slug
              }
              ... on DatoCmsSimpleWebsitePageModel {
                id: originalId
                slug
              }
            }
          }
        }
        ... on DatoCmsHeadingContentImageButtonBlock {
          noTopPadding
          noBottomPadding
          rowReverse
          id
          backgroundColor
          heading {
            value
          }
          content {
            value
            links {
              __typename
              ... on DatoCmsBlogArticleModel {
                id: originalId
                slug
              }
              ... on DatoCmsNewsArticleModel {
                id: originalId
                slug
              }
              ... on DatoCmsModularPage {
                id: originalId
                slug
              }
              ... on DatoCmsSimpleWebsitePageModel {
                id: originalId
                slug
              }
            }
          }
          featureImageDesktop {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
